var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"virtual_guard__phone_prompt virtual_guard__phone_landscape"},[_c('touch-events',{attrs:{"sublocation_id":_vm.sublocation_id},on:{"closePhoneValidation":function($event){return _vm.updateShowPhonePrompt(false)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }